const BRANCH_STORAGE_KEY = 'madina_branch_id';
const BRANCH_NAME_STORAGE_KEY = 'madina_branch_name';

const parseBranchId = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

/** Branch for the store currently open, from `?locationId=`. */
export const getBranchIdFromLocation = (): number | null => {
  if (typeof window === 'undefined') return null;
  return parseBranchId(new URLSearchParams(window.location.search).get('locationId'));
};

export const getStoredBranchId = (): number | null => {
  const fromUrl = getBranchIdFromLocation();
  if (fromUrl) return fromUrl;

  const direct = localStorage.getItem(BRANCH_STORAGE_KEY);
  if (direct) {
    return parseBranchId(direct);
  }

  try {
    const persisted = localStorage.getItem('recoil-persist');
    if (!persisted) return null;
    const parsed = JSON.parse(persisted) as Record<string, unknown>;
    return parseBranchId(parsed['@branchId']);
  } catch {
    return null;
  }
};

export const setStoredBranch = (branchId: number, branchName?: string) => {
  localStorage.setItem(BRANCH_STORAGE_KEY, String(branchId));
  if (branchName) {
    localStorage.setItem(BRANCH_NAME_STORAGE_KEY, branchName);
  }
};

export const getStoredBranchName = () => localStorage.getItem(BRANCH_NAME_STORAGE_KEY) ?? '';

export const clearStoredBranch = () => {
  localStorage.removeItem(BRANCH_STORAGE_KEY);
  localStorage.removeItem(BRANCH_NAME_STORAGE_KEY);
};

export const useTier1Commerce = () => getStoredBranchId() !== null;
